import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
	const [credentials, setCredentials] = useState({
		email: '',
		password: '',
	});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError('');

		const { error: signInError } = await supabase.auth.signInWithPassword({
			email: credentials.email.trim(),
			password: credentials.password,
		});

		setLoading(false);

		if (signInError) {
			setError(signInError.message || 'Invalid email or password');
			return;
		}

		navigate('/admin');
	};

	const handleChange = (e) => {
		setCredentials((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	};

	return (
		<div className='min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8'>
			<div className='sm:mx-auto sm:w-full sm:max-w-md'>
				<div className='flex justify-center'>
					<div className='w-16 h-16 bg-[#800020] rounded-full flex items-center justify-center'>
						<Icon name='Shield' className='h-8 w-8 text-white' />
					</div>
				</div>
				<h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>FEPA Admin Login</h2>
				<p className='mt-2 text-center text-sm text-gray-600'>
					Sign in to access the content management system
				</p>
			</div>

			<div className='mt-8 sm:mx-auto sm:w-full sm:max-w-md'>
				<div className='bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10'>
					<form className='space-y-6' onSubmit={handleSubmit}>
						{error && (
							<div className='bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md'>
								{error}
							</div>
						)}

						<div>
							<label htmlFor='email' className='block text-sm font-medium text-gray-700'>
								Email
							</label>
							<div className='mt-1'>
								<input
									id='email'
									name='email'
									type='email'
									autoComplete='email'
									required
									value={credentials.email}
									onChange={handleChange}
									className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-[#800020] focus:border-[#800020] sm:text-sm'
									placeholder='admin@yourdomain.com'
								/>
							</div>
						</div>

						<div>
							<label htmlFor='password' className='block text-sm font-medium text-gray-700'>
								Password
							</label>
							<div className='mt-1'>
								<input
									id='password'
									name='password'
									type='password'
									autoComplete='current-password'
									required
									value={credentials.password}
									onChange={handleChange}
									className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-[#800020] focus:border-[#800020] sm:text-sm'
									placeholder='Enter your password'
								/>
							</div>
						</div>

						<div>
							<button
								type='submit'
								disabled={loading}
								className='w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#800020] hover:bg-[#6b001a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#800020] disabled:opacity-50 disabled:cursor-not-allowed'
							>
								{loading ? (
									<>
										<Icon name='Loader' className='h-4 w-4 animate-spin mr-2' />
										Signing in...
									</>
								) : (
									'Sign in'
								)}
							</button>
						</div>
					</form>

					<p className='mt-6 text-center text-xs text-gray-500'>
						admin@fepalawpartners.com<br/>
						fepa2024
					</p>
				</div>
			</div>
		</div>
	);
};

export default AdminLogin;
